import React, { useState } from "react";
import PopupFooter from ".";
import bgHeader from "../../../../../assets/images/Mini-Game/header-mission.png";
import pieceA from "../../../../../assets/images/Mini-Game/piece-a.png";
import { Input } from "antd";
import iconFb from "../../../../../assets/images/Mini-Game/icon-fb.png";
import iconTelegram from "../../../../../assets/images/Mini-Game/icon-telegram.png";
import iconMessenger from "../../../../../assets/images/Mini-Game/icon-messenger.png";
import iconLinkExpired from "../../../../../assets/images/Mini-Game/icon-link-expired.png";
import {
  ID_TAB_MINI_GAME,
  TYPE_GIVE_PIECE,
  TYPE_GIVE_PIECE_SUCCESS,
  TYPE_REQUEST_PIECE,
} from "../../../../../helper/const";
import { useDispatch, useSelector } from "react-redux";
import {
  setDataPopupError,
  setOpenPopupGivePiece,
  setOpenPopupGivePieceSuccess,
} from "../../../../../Redux/futures/mini-game/action";
import { curStateMiniGame } from "../../../../../Redux/selector";
import copy from "copy-to-clipboard";
import ComponentGive from "./components/ComponentGive";
import { useNavigate } from "react-router";
import PATH from "../../../../../config/PATH";
import { postDataApi } from "../../../../../config/service";
import API_PATH from "../../../../../config/API_PATH";
import { useTranslation } from "react-i18next";
import { dataDetail } from "../DefineData";

export default function PopupGivePiece({ isOpen = true, setIsOpen, type }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dataMiniGame = useSelector(curStateMiniGame);
  const [isCopy, setIsCopy] = useState(false);

  const onClose = () => {
    dispatch(
      setOpenPopupGivePiece({
        isShow: false,
        type: null,
        link: "",
        data: null,
      })
    );
    setIsCopy(false);
  };

  const handleCopyLink = () => {
    copy(dataMiniGame.popupGivePiece?.link);
    setIsCopy(true);
  };

  const handleInviteUser = async () => {
    onClose();

    let dataApi = await postDataApi(API_PATH.miniGameReceiveInviteLink, {
      code: dataMiniGame.popupGivePiece?.data?.referral?.code,
    });
    // thất bại
    if (!dataApi?.data || !dataApi?.success) {
      const { dataAwardListMini = [] } = dataMiniGame;
      dataApi.award = dataAwardListMini[0];
      return dispatch(
        setOpenPopupGivePiece({
          isShow: true,
          type: TYPE_GIVE_PIECE.linkExpiredInviteUser,
          data: { dataApi },
        })
      );
    }

    // thành công
    return dispatch(
      setOpenPopupGivePieceSuccess({
        isShow: true,
        type: TYPE_GIVE_PIECE_SUCCESS.referral_successful,
        data: dataApi,
      })
    );
  };

  const handleGiveLinkGiveConfirm = async () => {
    onClose();
    const dataApi = await postDataApi(API_PATH.miniGameReceivePieceLink, {
      code: dataMiniGame.popupGivePiece?.link,
      type: dataMiniGame.popupGivePiece?.data?.data?.typeWeb,
    });

    if (!dataApi?.success) {
      // return dispatch(
      //   setOpenPopupGivePiece({
      //     isShow: true,
      //     type: TYPE_GIVE_PIECE.linkExpired,
      //     data: { dataApi },
      //   })
      // );
      return dispatch(
        setDataPopupError({
          isOpen: true,
          message: dataApi?.errorMessage || "",
        })
      );
    }

    const dataDetail = dataMiniGame.popupGivePiece?.data;
    dispatch(
      setOpenPopupGivePieceSuccess({
        isShow: true,
        type: TYPE_GIVE_PIECE_SUCCESS.receive,
        data: { ...dataApi, dataDetail },
      })
    );
  };

  const handleGiveLinkRequestConfirm = async () => {
    onClose();
    const dataApi = await postDataApi(API_PATH.miniGameSendPieceLink, {
      code: dataMiniGame.popupGivePiece?.link,
      type: dataMiniGame.popupGivePiece?.data?.data?.typeWeb,
    });
    // console.log("dataApi", dataApi);

    if (!dataApi?.success) {
      return dispatch(
        setDataPopupError({
          isOpen: true,
          message: dataApi?.errorMessage || "",
        })
      );
      //  return dispatch(
      //     setOpenPopupGivePiece({
      //       isShow: true,
      //       type: TYPE_GIVE_PIECE.linkExpired,
      //       data: { dataApi },
      //     })
      //   );
    }
    const dataDetail = dataMiniGame.popupGivePiece?.data;
    // thành công
    dispatch(
      setOpenPopupGivePieceSuccess({
        isShow: true,
        type: TYPE_GIVE_PIECE_SUCCESS.give,
        data: { ...dataApi, dataDetail },
      })
    );
  };

  if (!type) {
    return null;
  }

  return (
    <div className='popup-minigame__2025'>
      <PopupFooter
        isOpen={isOpen}
        onClose={onClose}
        className={"popup-rule-mini"}
      >
        {type === TYPE_GIVE_PIECE.shareLink ? (
          <>
            <div className='header-mini-popup-rule'>
              <img src={bgHeader} alt='' className='img-rule-mini' />
              <div className='content-rule-mini'>
                {t("mini_game.pop_up_give_piece.title")}
              </div>
            </div>
            <div className='box-content-minigame-popup__container container-give-piece'>
              <div className='send-link-container'>
                <p className='container-title-text'>
                  {t("mini_game.pop_up_give_piece.send_link_title")}
                </p>
                <div className='url-container'>
                  <Input
                    type='text'
                    value={dataMiniGame.popupGivePiece?.link}
                    readOnly
                  />
                  <button
                    className='btn-give-piece copy-link'
                    onClick={handleCopyLink}
                  >
                    {isCopy
                      ? t("mini_game.pop_up_invite_friend.copied")
                      : t("mini_game.pop_up_invite_friend.copy")}
                  </button>
                </div>
              </div>

              <div className='share-social-media-container'>
                <p className='container-title-text'>
                  {t("mini_game.pop_up_invite_friend.share")}
                </p>
                <div className='link-wrapper'>
                  <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${dataMiniGame.popupGivePiece?.link}`}
                    className='social-media-link scale-hover-item'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <img src={iconFb} alt='' />
                  </a>
                  <a
                    href={`https://t.me/share/url?url=${dataMiniGame.popupGivePiece?.link}`}
                    className='social-media-link scale-hover-item'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <img src={iconTelegram} alt='' />
                  </a>
                  {/* <a href={`https://www.facebook.com/dialog/send?link=${dataMiniGame.popupGivePiece?.link}&app_id=YOUR_APP_ID&redirect_uri=${dataMiniGame.popupGivePiece?.link}`} target="_blank" rel="noopener noreferrer">
                    <img src={iconMessenger} alt="" />
                  </a> */}
                </div>
              </div>

              <p className='footer-text'>
                {`${t("mini_game.pop_up_give_piece.can_only_give").replace(
                  "X",
                  dataMiniGame.configMiniGame?.minigame?.max_give_piece
                )} ${t("mini_game.pop_up_give_piece.turns_left")
                  .replace(
                    "X",
                    dataMiniGame.configMiniGame?.giveReceiveTurnLeft
                  )
                  .replace(
                    "pieces",
                    dataMiniGame.configMiniGame?.giveReceiveTurnLeft > 1
                      ? "pieces"
                      : "piece"
                  )}`}
              </p>
            </div>
          </>
        ) : type === TYPE_GIVE_PIECE.linkExpired ? (
          <>
            <div className='header-mini-popup-rule'>
              <img src={bgHeader} alt='' className='img-rule-mini' />
              <div className='content-rule-mini'>
                {t("mini_game.link_expired")}
              </div>
            </div>
            <div className='box-content-minigame-popup__container container-give-piece'>
              <img src={iconLinkExpired} alt='' />
              <div className='text-group'></div>
              <p className='container-text'>
                {dataMiniGame?.popupGivePiece?.data?.dataApi?.errorMessage}
              </p>
              <button
                className='btn-give-piece'
                onClick={() => {
                  onClose();
                }}
              >
                {t("event_new_year.close")}
              </button>
            </div>
          </>
        ) : type === TYPE_GIVE_PIECE.linkExpiredInviteUser ? (
          <>
            <div className='header-mini-popup-rule'>
              <img src={bgHeader} alt='' className='img-rule-mini' />
              <div className='content-rule-mini'>
                {t("mini_game.link_expired")}
              </div>
            </div>
            <div className='box-content-minigame-popup__container container-give-piece'>
              <img src={iconLinkExpired} alt='' />
              <div className='text-group'>
                <p className='container-text'>
                  {dataMiniGame.popupGivePiece?.data?.dataApi?.errorMessage ||
                    ""}
                </p>
              </div>
              <p className='container-text'>
                {t("mini_game.join_now_to_collect").replace(
                  "XXXXXXXXXXXX",
                  dataMiniGame?.popupGivePiece?.data?.dataApi?.award?.name || ""
                )}
              </p>
              <button
                className='btn-give-piece'
                onClick={() => {
                  navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.home}`);
                  onClose();
                }}
              >
                {/* Join now */}
                {t("mini_game.join_now")}
              </button>
            </div>
          </>
        ) : type === TYPE_GIVE_PIECE.give ? (
          <ComponentGive
            bgHeader={bgHeader}
            pieceA={pieceA}
            data={dataMiniGame.popupGivePiece?.data}
          />
        ) : type === TYPE_GIVE_PIECE.accept ? (
          <>
            <div className='header-mini-popup-rule'>
              <img src={bgHeader} alt='' className='img-rule-mini' />
              <div className='content-rule-mini'>
                {t("mini_game.pop_up_accept_piece.title")}
              </div>
            </div>
            <div className='box-content-minigame-popup__container container-give-piece'>
              <p className='title-user-send'>
                {/* User {dataMiniGame.popupGivePiece?.data?.data?.owner_isdn} wants
                to give you a piece of Prize{" "}
                {dataMiniGame.popupGivePiece?.data?.data?.award_name} - Piece (
                {dataMiniGame.popupGivePiece?.data?.data?.piece_name}). */}
                {t("mini_game.pop_up_accept_piece.user_give")
                  .replace(
                    "X",
                    dataMiniGame.popupGivePiece?.data?.data?.owner_isdn || ""
                  )
                  .replace(
                    "Y",
                    `${
                      dataMiniGame.popupGivePiece?.data?.data?.award_name || ""
                    } - Piece (
                ${dataMiniGame.popupGivePiece?.data?.data?.piece_name || ""})`
                  )}
              </p>
              <p className='title-have'>
                {t("mini_game.pop_up_puzzle_piece.you_have")}
              </p>
              <div className='piece-container' style={{ textAlign: "center" }}>
                <img
                  src={dataMiniGame.popupGivePiece?.data?.data?.image}
                  alt='image-piece'
                  className='piece-image'
                />
                <p className='piece-name'>
                  {dataMiniGame.popupGivePiece?.data?.data?.piece_total_number}{" "}
                  prize {dataMiniGame.popupGivePiece?.data?.data?.award_name} -
                  Piece ({dataMiniGame.popupGivePiece?.data?.data?.piece_name})
                </p>
              </div>

              <p className='title-give'>
                {t("mini_game.pop_up_accept_piece.want_to_receive")}
              </p>
              <button
                className='btn-give-piece'
                onClick={handleGiveLinkGiveConfirm}
              >
                {t("mini_game.pop_up_accept_piece.accept")}
              </button>
              <button className='btn-cancel-accept' onClick={onClose}>
                {t("mini_game.pop_up_accept_piece.cancel")}
              </button>
              <p className='footer-text'>
                {`${t("mini_game.pop_up_give_piece.can_only_give").replace(
                  "X",
                  dataMiniGame.configMiniGame?.minigame?.max_give_piece
                )} ${t("mini_game.pop_up_give_piece.turns_left")
                  .replace(
                    "X",
                    dataMiniGame.configMiniGame?.giveReceiveTurnLeft
                  )
                  .replace(
                    "pieces",
                    dataMiniGame.configMiniGame?.giveReceiveTurnLeft > 1
                      ? "pieces"
                      : "piece"
                  )}`}
              </p>
            </div>
          </>
        ) : type === TYPE_REQUEST_PIECE.requestLink ? (
          <>
            <div className='header-mini-popup-rule'>
              <img src={bgHeader} alt='' className='img-rule-mini' />
              <div className='content-rule-mini'>
                {t("mini_game.pop_up_request_piece.title")}
              </div>
            </div>
            <div className='box-content-minigame-popup__container container-give-piece'>
              <div className='send-link-container'>
                <p className='container-title-text'>
                  {t("mini_game.pop_up_request_piece.send_link_title")}
                </p>
                <div className='url-container'>
                  <Input
                    type='text'
                    value={dataMiniGame.popupGivePiece?.link}
                    readOnly
                  />
                  <button
                    className='btn-give-piece copy-link'
                    onClick={handleCopyLink}
                  >
                    {isCopy
                      ? t("mini_game.pop_up_invite_friend.copied")
                      : t("mini_game.pop_up_invite_friend.copy")}
                  </button>
                </div>
              </div>

              <div className='share-social-media-container'>
                <p className='container-title-text'>
                  {t("mini_game.pop_up_invite_friend.share")}
                </p>
                <div className='link-wrapper'>
                  <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${dataMiniGame.popupGivePiece?.link}`}
                    className='social-media-link scale-hover-item'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <img src={iconFb} alt='' />
                  </a>
                  <a
                    href={`https://t.me/share/url?url=${dataMiniGame.popupGivePiece?.link}`}
                    className='social-media-link scale-hover-item'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <img src={iconTelegram} alt='' />
                  </a>
                  {/* <a href={`https://www.facebook.com/dialog/send?link=${dataMiniGame.popupGivePiece?.link}&app_id=YOUR_APP_ID&redirect_uri=${dataMiniGame.popupGivePiece?.link}`} target="_blank" rel="noopener noreferrer">
                    <img src={iconMessenger} alt="" />
                  </a> */}
                </div>
              </div>

              <p className='footer-text'>
                {`${t("mini_game.pop_up_give_piece.can_only_give").replace(
                  "X",
                  dataMiniGame.configMiniGame?.minigame?.max_give_piece
                )} ${t("mini_game.pop_up_give_piece.turns_left")
                  .replace(
                    "X",
                    dataMiniGame.configMiniGame?.giveReceiveTurnLeft
                  )
                  .replace(
                    "pieces",
                    dataMiniGame.configMiniGame?.giveReceiveTurnLeft > 1
                      ? "pieces"
                      : "piece"
                  )}`}
              </p>
            </div>
          </>
        ) : type === TYPE_REQUEST_PIECE.requestConfirm ? (
          <>
            <div className='header-mini-popup-rule'>
              <img src={bgHeader} alt='' className='img-rule-mini' />
              <div className='content-rule-mini'>
                {t("mini_game.pop_up_request_piece.title")}
              </div>
            </div>
            <div className='box-content-minigame-popup__container container-give-piece'>
              <p className='title-user-send'>
                {/* User {dataMiniGame.popupGivePiece?.data?.data?.owner_isdn} wants
                to request for a piece of your Prize{" "}
                {dataMiniGame.popupGivePiece?.data?.data?.award_name} - Piece (
                {dataMiniGame.popupGivePiece?.data?.data?.piece_name}) */}
                {t("mini_game.pop_up_request_piece.user_req")
                  .replace(
                    "X",
                    dataMiniGame.popupGivePiece?.data?.data?.owner_isdn || ""
                  )
                  .replace(
                    "Y",
                    `${
                      dataMiniGame.popupGivePiece?.data?.data?.award_name || ""
                    } - Piece (${
                      dataMiniGame.popupGivePiece?.data?.data?.piece_name || ""
                    })`
                  )}
              </p>
              <p className='title-have'>
                {t("mini_game.pop_up_puzzle_piece.you_have")}
              </p>
              <div className='piece-container'>
                <img
                  src={dataMiniGame.popupGivePiece?.data?.data?.image || pieceA}
                  alt=''
                  className='piece-image'
                />
                <p className='piece-name'>
                  1 prize {dataMiniGame.popupGivePiece?.data?.data?.award_name}{" "}
                  - Piece ({dataMiniGame.popupGivePiece?.data?.data?.piece_name}
                  )
                </p>
              </div>

              <p className='title-give'>
                {t("mini_game.pop_up_request_piece.want_to_give")}
              </p>
              <button
                className='btn-give-piece'
                onClick={handleGiveLinkRequestConfirm}
              >
                {t("mini_game.pop_up_request_piece.give")}
              </button>
              <button className='btn-cancel-accept' onClick={onClose}>
                {t("mini_game.pop_up_request_piece.cancel")}
              </button>
              <p className='footer-text'>
                {`${t("mini_game.pop_up_give_piece.can_only_give").replace(
                  "X",
                  dataMiniGame.configMiniGame?.minigame?.max_give_piece
                )} ${t("mini_game.pop_up_give_piece.turns_left")
                  .replace(
                    "X",
                    dataMiniGame.configMiniGame?.giveReceiveTurnLeft
                  )
                  .replace(
                    "pieces",
                    dataMiniGame.configMiniGame?.giveReceiveTurnLeft > 1
                      ? "pieces"
                      : "piece"
                  )}`}
              </p>
            </div>
          </>
        ) : type === TYPE_GIVE_PIECE.inviteUser ? (
          <>
            <div className='header-mini-popup-rule '>
              <img src={bgHeader} alt='' className='img-rule-mini' />
              <div className='content-rule-mini'>
                {t("mini_game.pop_up_invite_friend.title")}
              </div>
            </div>
            <div className='box-content-minigame-popup__container container-give-piece'>
              <div className='send-link-container'>
                <div
                  style={{
                    color: "#64310B",
                    fontSize: "18px",
                    fontWeight: "500",
                    lineHeight: "22px",
                  }}
                >
                  {t("mini_game.pop_up_invite_friend.invite_friend_title")}
                </div>
                <p
                  className='description-text'
                  style={{
                    color: "rgba(108, 115, 127, 1)",
                    fontSize: "16px",
                    fontWeight: "500",
                    fontStyle: "italic",
                  }}
                >
                  {t("mini_game.pop_up_invite_friend.invite_friend_desc_1")}
                  <br />
                  <span
                    style={{
                      marginTop: 12,
                      display: 'inline-block'
                    }}
                  >
                    {t("mini_game.pop_up_invite_friend.invite_friend_desc_2")}
                  </span>
                </p>
                <div className='url-container container-popup__intive'>
                  <Input
                    type='text'
                    value={dataMiniGame.popupGivePiece?.link}
                    readOnly
                  />
                </div>
                <button
                  className='btn-give-piece copy-link'
                  onClick={handleCopyLink}
                  style={{ height: "60px" }}
                >
                  {isCopy
                    ? t("mini_game.pop_up_invite_friend.copied")
                    : t("mini_game.pop_up_invite_friend.copy")}
                </button>
              </div>

              <div className='share-social-media-container'>
                <p className='container-title-text'>
                  {t("mini_game.pop_up_invite_friend.share")}
                </p>
                <div className='link-wrapper'>
                  <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${dataMiniGame.popupGivePiece?.link}`}
                    className='social-media-link scale-hover-item'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <img src={iconFb} alt='' />
                  </a>
                  <a
                    href={`https://t.me/share/url?url=${dataMiniGame.popupGivePiece?.link}`}
                    className='social-media-link scale-hover-item'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <img src={iconTelegram} alt='' />
                  </a>
                </div>
              </div>
            </div>
          </>
        ) : type === TYPE_GIVE_PIECE.confirmInviteUser ? (
          <>
            <div className='header-mini-popup-rule '>
              <img src={bgHeader} alt='' className='img-rule-mini' />
              <div className='content-rule-mini'>
                {t("mini_game.pop_up_invite_friend.confirm_ref_title")}
              </div>
            </div>
            <div className='box-content-minigame-popup__container container-give-piece'>
              <div className='send-link-container'>
                <div
                  style={{
                    color: "#64310B",
                    fontSize: "18px",
                    fontWeight: "500",
                    lineHeight: "22px",
                  }}
                >
                  {t("mini_game.pop_up_invite_friend.confirm_ref").replace(
                    "X",
                    dataMiniGame.popupGivePiece?.data?.referral?.owner_isdn ||
                      ""
                  )}
                </div>
                <p
                  className='description-text'
                  style={{
                    color: "rgba(108, 115, 127, 1)",
                    fontSize: "16px",
                    fontWeight: "500",
                    fontStyle: "italic",
                  }}
                >
                  {`
                    ${t("mini_game.pop_up_invite_friend.confirm_ref_sub")} ${t(
                    "mini_game.pop_up_invite_friend.confirm_ref_sub_trailing.prefix"
                  )} ${
                    dataMiniGame.popupGivePiece?.data?.superCoinAdd
                      ? `${dataMiniGame.popupGivePiece?.data?.superCoinAdd} SUPER Coin`
                      : ""
                  }
                  ${
                    dataMiniGame.popupGivePiece?.data?.normalCoinAdd
                      ? `${dataMiniGame.popupGivePiece?.data?.normalCoinAdd} Coin`
                      : ""
                  } ${t(
                    "mini_game.pop_up_invite_friend.confirm_ref_sub_trailing.suffix"
                  )}
                  `}
                </p>
                <button
                  className='btn-give-piece copy-link'
                  onClick={handleInviteUser}
                  style={{ height: "60px" }}
                >
                  {t("mini_game.pop_up_invite_friend.confirm")}
                </button>
                <button
                  className='btn-cancel-accept'
                  onClick={() => {
                    onClose();
                    navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.home}`);
                  }}
                >
                  {t("mini_game.pop_up_invite_friend.cancel")}
                </button>
              </div>
            </div>
          </>
        ) : null}
      </PopupFooter>
    </div>
  );
}
